import { MOBILE_VIEW_VOLUME_OPTIONS } from '@paradigm/features/src/leaderboard/entities/shared';
import {
  useVolumesListState,
  useVolumesListActions,
} from '@paradigm/features/src/leaderboard/contexts/volumes-list';
import BaseMenuSelect from '#/components/Leaderboard/shared/BaseMenuSelect';

export default function MobileMenuSection() {
  const { mobileView } = useVolumesListState();
  const { changeMobileView } = useVolumesListActions();

  return (
    <BaseMenuSelect
      value={mobileView}
      onChange={changeMobileView}
      options={MOBILE_VIEW_VOLUME_OPTIONS}
    />
  );
}
